import { User } from 'lucide-react';

const AVATAR_COLORS = [
  'bg-rose-400',
  'bg-sky-400',
  'bg-violet-400',
  'bg-amber-400',
  'bg-emerald-400',
  'bg-pink-400',
  'bg-teal-400',
  'bg-orange-400',
  'bg-indigo-400',
  'bg-lime-500',
];

function getColorForName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return (parts[0]?.[0] || '?').toUpperCase();
}

interface ContactAvatarProps {
  photoUrl?: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const SIZE_CLASSES = {
  sm: 'size-10 text-sm',
  md: 'size-12 text-base',
  lg: 'size-14 text-lg',
  xl: 'size-24 text-3xl',
};

export default function ContactAvatar({
  photoUrl,
  name,
  size = 'md',
  className = '',
}: ContactAvatarProps) {
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className={`${SIZE_CLASSES[size].split(' ')[0]} rounded-full object-cover ${className}`}
        referrerPolicy="no-referrer"
      />
    );
  }

  const color = getColorForName(name || '');
  const initials = getInitials(name || '');

  return (
    <div
      className={`${SIZE_CLASSES[size]} ${color} rounded-full flex items-center justify-center text-white font-bold ${className}`}
    >
      {name ? initials : <User size={size === 'xl' ? 32 : size === 'lg' ? 20 : 16} />}
    </div>
  );
}
